import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import Media from 'components/shared/Media/Media';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn, getColorway } from 'utils/styles';
import { Colorways } from 'types/constants';
import { CardGridItemProps } from './types';

interface Props extends CardGridItemProps {
  cardColorway?: Colorways;
}

const CardGridItem = ({ sys, media, headline, copy, cta, cardColorway = Colorways.Primary }: Props) => {
  return (
    <div
      className={cn('flex h-full flex-col overflow-hidden rounded-3xl', getColorway(cardColorway))}
      data-testid="card-grid-item">
      {media?.url && (
        <div className="px-6 pt-6" {...liveUpdateAttrs(sys?.id, 'media')}>
          <div className="relative aspect-[4/3] overflow-hidden rounded-2xl">
            <Media media={{ ...media, fill: true }} roundedImage={false} sizes="(max-width: 768px) 90vw, 33vw" />
          </div>
        </div>
      )}
      <div className="flex flex-1 flex-col px-6 pt-8 pb-6">
        <div className="flex flex-col gap-4">
          <div
            className="font-sans text-heading-sm font-semibold md:text-heading-md"
            {...liveUpdateAttrs(sys?.id, 'headline')}
            data-testid="card-grid-item-headline">
            <RichTextHeadline headline={headline} level="h3" />
          </div>
          {copy && (
            <div className="font-sans text-body-saans" {...liveUpdateAttrs(sys?.id, 'copy')}>
              <RichTextCopy copy={copy} ySpacing="none" />
            </div>
          )}
        </div>
        {isValidCta(cta) && (
          <div className="mt-auto pt-9" {...liveUpdateAttrs(sys?.id, 'cta')}>
            <CTA cta={cta} variant="outline" className="max-w-max" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardGridItem;
